import { render, staticRenderFns } from "./PromiseView.vue?vue&type=template&id=42059e18"
import script from "./PromiseView.vue?vue&type=script&lang=ts"
export * from "./PromiseView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports